import React from 'react';
import { Grid } from '@material-ui/core';
import Table from '../Table';
import { loanApplicationAction } from '../../redux/actions/applicationAction';

const List = ({
  data,
  columns,
  totalCount,
  loading,
  dispatch,
  currentFilters,
}) => {
  return (
    <div style={{ width: '100%', margin: '' }}>
      <Grid xs={12}>
        <Table
          columns={columns}
          data={data}
          total={totalCount}
          loading={loading}
          onPageChange={(page, limit) => {
            dispatch(
              loanApplicationAction({
                ...currentFilters,
                page: page - 1,
                limit,
              })
            );
          }}
        />
      </Grid>
    </div>
  );
};

export default List;
